import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import { Link } from 'core/routing';

import {
  ModalTitle,
  ModalSubtitle,
  FullWidthDivider,
} from 'legacyComponents/styled/lib';
import Icon from 'components/Icon';
import { Modal } from 'apps/modals/views/modal';

import { List, ContainerInfo, ParagraphStyled } from './styles';

@withNamespaces()
@observer
export class ModalFreeTrialInfo extends Modal {
  render() {
    return (
      <>
        <ModalTitle variant='secondary' level={2}>
          <Trans>
            Try the {this.props.spaceType === 'PROFILE' ? 'Individual' : 'Team'}{' '}
            plan for free, for 30 days
          </Trans>
        </ModalTitle>
        <ModalSubtitle level={3}>
          <Trans>(No credit card required)</Trans>
        </ModalSubtitle>
        <FullWidthDivider marginTop='1rem' />
        <ContainerInfo>
          <ParagraphStyled>
            <strong>
              <Trans>During the 30-day free trial</Trans>:
            </strong>
          </ParagraphStyled>
          <List>
            <li>
              <Icon name='check' /> <Trans>Unlimited public projects</Trans>
            </li>
            <li>
              <Icon name='check' /> <Trans>Unlimited private projects</Trans>
            </li>
            <li>
              <Icon name='check' />{' '}
              <Trans>Unlimited public collaborators</Trans>
            </li>
            <li>
              <Icon name='check' />{' '}
              <Trans>Unlimited private collaborators</Trans>
            </li>
            {this.props.spaceType !== 'PROFILE' && (
              <li>
                <Icon name='check' /> <Trans>Team management</Trans>
              </li>
            )}
          </List>
          <ParagraphStyled>
            <strong>
              <Trans>
                You may upgrade to a paid subscription at any time, or once the
                free trial has expired.
              </Trans>
            </strong>{' '}
            <Link name='home.pricing'>
              <Trans>More information about our Plans</Trans>
            </Link>
          </ParagraphStyled>
        </ContainerInfo>
      </>
    );
  }
}

ModalFreeTrialInfo.propTypes = {
  fadeIn: PropTypes.func,
  clickCancel: PropTypes.func,
};
